$(document).ready(function () {
    // Record default value in a data attr for re-hiding
    $('.pii-text-control').each(function (i, e) {
        e = $(e);
        e.data('hidden-text', e.find('a').text());
        e.data('fa-default', e.find('.fa').attr('class'))
    });

    $('.pii-text-control').click(function (event) {
        replaceText = function (e, text) {
            e.contents().filter(function() {
                // Text elements - avoids replacing the icon
                return this.nodeType == 3;
            })
            .replaceWith(text)
        }

        // Don't let browser treat it as a normal link click
        event.preventDefault();

        wrapper = $(event.currentTarget);
        link = wrapper.find('a');
        hidden = link.text() == wrapper.data('hidden-text');

        if (hidden == false) {
            replaceText(link, wrapper.data('hidden-text'))
            return;
        }

        wrapper.find('.fa').removeClass().addClass('fa fa-circle-o-notch fa-spin');
        $.get({
            url: link.attr('href'),
        })
        .done(function (value) {
            value = [value.substr(0,3), value.substr(3, 2), value.substr(5)];
            replaceText(link, ' ' + value.join('-'));
        })
        .fail(function () {
            $.notify('Failed to reveal the hidden value.');
        })
        .always(function () {
            wrapper.find('.fa').removeClass().addClass(wrapper.data('fa-default'));
        });

    })

    /* ******************************************** */
    /*             Form input controls              */
    /* ******************************************** */

    // If the value has never been set, element is unlocked by default.
    $('.ssn-edit-toggle ~ input:enabled').mask('000-00-0000');

    $('.ssn-edit-toggle ~ input').focus(function (event) {
        input = $(event.target).attr('type', 'text');
    }).blur(function (event) {
        input = $(event.target).attr('type', 'password');
    });

    $('.ssn-edit-toggle a').click(function (event) {
        event.preventDefault();

        // Find the associated input element & other useful things
        link = $(event.currentTarget);
        input = link.closest('.input-group').find('input');
        locked = (input.attr('disabled') == 'disabled');
        icon = link.find('i');

        // Do nothing. We've already loaded the SSN.
        if (locked == false) {
            input.focus();
            return;
        }

        // For cosigners, we don't retrieve SSN. They have to enter it new.
        if (link.attr('href') == undefined) {
            icon.removeClass().addClass('fa fa-unlock-alt');
            input.mask('000-00-0000');
            input.attr('placeholder', '000-00-000');
            input.attr('disabled', false).focus();

            return;
        }

        icon.removeClass().addClass('fa fa-circle-o-notch fa-spin');
        $.get({
            url: link.attr('href'),
        })
        .done(function (value) {
            input.val(value);

            icon.removeClass().addClass('fa fa-unlock-alt');
            input.mask('000-00-0000');
            input.attr('placeholder', '000-00-000');
            input.attr('disabled', false).focus();
        })
        .fail(function () {
            $.notify('Failed to reveal the hidden value.');
            icon.removeClass().addClass('fa fa-lock');
        });
    });
});
